/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliGroupDto } from '../../models/amoxcalli-group-dto';

export interface ApiGroupsIdGet$Json$Params {
  id: string;
}

export function apiGroupsIdGet$Json(http: HttpClient, rootUrl: string, params: ApiGroupsIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliGroupDto>> {
  const rb = new RequestBuilder(rootUrl, apiGroupsIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliGroupDto>;
    })
  );
}

apiGroupsIdGet$Json.PATH = '/api/groups/{id}';
